import AxiosHttpClient from 'infra/http/axios-http-client'
import { makeAccessTokenCache } from '../cache/set-access-token-cache-factory'
import { makeUserService } from '../services/user-service-factory'

export const makeAxiosHttpClient = (): AxiosHttpClient => new AxiosHttpClient(makeAccessTokenCache(), makeUserService())
